/* Constants */
import {DAVINCI_EVENT_NAMES} from '../../modules/analytics/davinci/davinciConstants'

/* Utils */
import {
  generateAsyncActionCreators,
} from '../core/reduxUtils'
import {
  generateProductListEventRequest,
  generateProductClickEventRequest,
  generateAddToCartClickEventRequest,
  generatePreOrderClickEventRequest,
  generateChangeVariantEventRequest,
  generateOpenVariantPopupEventRequest,
  generateCloseVariantPopupEventRequest,
  generateFeedbackViewEventRequest,
  generateFeedbackClickEventRequest,
  generateFilterWidgetClickEventRequest,
  generateHomePageViewEvent,
  generateRemoveFiltersEvent,
  generateSponsoredProductClick,
  generateSponsoredProductView,
  generateCampaignTagClickEvent,
  generateImageViewEvent,
  generateProductListViewData,
  generateProductViewEvent,
} from '../../modules/analytics/analyticsUtils'

const sendPageLoadEventActionCreators = generateAsyncActionCreators(
  'SEND_PAGE_LOAD_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PAGE_LOAD,
      eventData: {},
    },
  }),
);

const sendProductListEventActionCreators = generateAsyncActionCreators(
  'SEND_PRODUCT_LIST_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_LIST,
      eventData: generateProductListEventRequest(params),
    },
  }),
);

const sendProductClickEventActionCreators = generateAsyncActionCreators(
  'SEND_PRODUCT_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_CLICK,
      eventData: generateProductClickEventRequest(params),
    },
  }),
);

const sendProductClickAnalyticsEventActionCreators = generateAsyncActionCreators(
  'SEND_PRODUCT_CLICK_ANALYTICS_EVENT',
  (params) => ({
    params,
  }),
);

const sendAddToCartClickEventActionCreators = generateAsyncActionCreators(
  'SEND_ADD_TO_CART_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.ADD_TO_CART_CLICK,
      eventData: generateAddToCartClickEventRequest(params),
    },
  }),
);

const sendAddToCartClickAnalyticsEventActionCreators = generateAsyncActionCreators(
  'SEND_ADD_TO_CART_CLICK_ANALYTICS_EVENT',
  (params) => ({
    params,
  }),
);

const sendChangeVariantClickEventActionCreators = generateAsyncActionCreators(
  'SEND_CHANGE_VARIANT_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.CHANGE_VARIANT,
      eventData: generateChangeVariantEventRequest(params),
    },
  }),
);

const sendOpenVariantPopupEventActionCreators = generateAsyncActionCreators(
  'SEND_OPEN_VARIANT_POPUP_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.VIEW_VARIANT_LIST,
      eventData: generateOpenVariantPopupEventRequest(params),
    },
  }),
);

const sendCloseVariantPopupEventActionCreators = generateAsyncActionCreators(
  'SEND_CLOSE_VARIANT_POPUP_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.CLOSE_VARIANT_LIST,
      eventData: generateCloseVariantPopupEventRequest(params),
    },
  }),
);

const sendPreOrderClickEventActionCreators = generateAsyncActionCreators(
  'SEND_PRE_ORDER_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRE_ORDER_CLICK,
      eventData: generatePreOrderClickEventRequest(params),
    },
  }),
);

const sendWebtrekkEventActionCreators = generateAsyncActionCreators(
  'SEND_WEBTREKK_EVENT',
  (params) => ({
    params,
  }),
);

const sendFeedbackViewEventActionCreators = generateAsyncActionCreators(
  'SEND_FEEDBACK_VIEW_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.FEEDBACK_VIEW,
      eventData: generateFeedbackViewEventRequest(params),
    },
  }),
);

const sendFeedbackClickEventActionCreators = generateAsyncActionCreators(
  'SEND_FEEDBACK_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.FEEDBACK_CLICK,
      eventData: generateFeedbackClickEventRequest(params),
    },
  }),
);

const sendFilterWidgetClickEventActionCreators = generateAsyncActionCreators(
  'SEND_FILTER_WIDGET_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.FILTER_WIDGET_CLICK,
      eventData: generateFilterWidgetClickEventRequest(params),
    },
  }),
);

const sendTypoCorrectionViewEventActionCreators = generateAsyncActionCreators(
  'SEND_TYPO_CORRECTION_VIEW_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.TYPO_CORRECTION_VIEW,
      eventData: params,
    },
  }),
);

const sendTypoCorrectionClickEventActionCreators = generateAsyncActionCreators(
  'SEND_TYPO_CORRECTION_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.TYPO_CORRECTION_CLICK,
      eventData: params,
    },
  }),
);

const sendRecoProductsClickEventActionCreators = generateAsyncActionCreators(
  'SEND_RECO_PRODUCTS_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.RECO_PRODUCTS_CLICK,
      eventData: params,
    },
  }),
);

const sendRecoProductsViewEventActionCreators = generateAsyncActionCreators(
  'SEND_RECO_PRODUCTS_VIEW_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.RECO_PRODUCTS_VIEW,
      eventData: params,
    },
  }),
);

const sendRecoProductsArrowClickEventActionCreators = generateAsyncActionCreators(
  'SEND_RECO_PRODUCTS_ARROW_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.RECO_PRODUCTS_ARROW_CLICK,
      eventData: params,
    },
  }),
);

const sendDealOfTheDayTitleClickEventActionCreators = generateAsyncActionCreators(
  'SEND_DEAL_OF_THE_DAY_TITLE_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.LINK_CLICK,
      eventData: params,
    },
  }),
);

const sendDealOfTheDayProductsClickEventActionCreators = generateAsyncActionCreators(
  'SEND_DEAL_OF_THE_DAY_PRODUCT_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_CAROUSEL_CLICK,
      eventData: params,
    },
  }),
);

const sendDealOfTheDayArrowClickEventActionCreators = generateAsyncActionCreators(
  'SEND_DEAL_OF_THE_DAY_ARROW_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_CAROUSEL_ARROW_CLICK,
      eventData: params,
    },
  }),
);

const sendDealOfTheDayViewEventActionCreators = generateAsyncActionCreators(
  'SEND_DEAL_OF_THE_DAY_VIEW_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_CAROUSEL_VIEW,
      eventData: params,
    },
  }),
);

const sendFilterFacetClickEventActionCreators = generateAsyncActionCreators(
  'SEND_FILTER_FACET_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.FILTER_FACET_CLICK,
      eventData: params,
    },
  }),
);

const sendMultiFilterFacetClickEventActionCreators = generateAsyncActionCreators(
  'SEND_MULTI_FILTER_FACET_CLICK_EVENT',
  (params) => ({
    params: {
      eventArray: params?.map(item => ({
        eventName: DAVINCI_EVENT_NAMES.FILTER_FACET_CLICK,
        eventData: item,
      }))
    },
  }),
);

const sendSortClickEventActionCreators = generateAsyncActionCreators(
  'SEND_SORT_CLICK_EVENT',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.SORT_CLICK,
      eventData: params,
    },
  }),
);

const sendSortClickAnalyticsEventActionCreators = generateAsyncActionCreators(
  'SEND_SORT_CLICK_ANALYTICS_EVENT',
  (params) => ({
    params,
  }),
);

const sendSmartFilterViewEventActionCreators = generateAsyncActionCreators(
  'SEND_SMART_FILTER_VIEW',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.SMART_FILTER_VIEW,
      eventData: params,
    },
  }),
);

const sendHomePageViewEventActionCreators = generateAsyncActionCreators(
  'SEND_HOME_PAGE_VIEW',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.HOME_PAGE_VIEW,
      eventData: generateHomePageViewEvent(params),
    },
  }),
);

const sendRemoveFiltersEventActionCreators = generateAsyncActionCreators(
  'SEND_REMOVE_FILTERS',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.REMOVE_FILTERS,
      eventData: generateRemoveFiltersEvent(params),
    },
  }),
);

const sendSponsoredProductViewEventActionCreators = generateAsyncActionCreators(
  'SEND_SPONSORED_PRODUCT_VIEW',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.SPONSORED_PRODUCT_VIEW,
      eventData: generateSponsoredProductView(params),
    },
  }),
);

const sendSponsoredProductClickEventActionCreators = generateAsyncActionCreators(
  'SEND_SPONSORED_PRODUCT_CLICK',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.SPONSORED_PRODUCT_CLICK,
      eventData: generateSponsoredProductClick(params),
    },
  }),
);

const sendProductListViewEventActionCreators = generateAsyncActionCreators(
  'SEND_PRODUCT_LIST_VIEW',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_LIST_VIEW,
      eventData: generateProductListViewData(params),
    },
  }),
);

const sendCampaignTagClickEventActionCreators = generateAsyncActionCreators(
  'SEND_CAMPAIGN_TAG_CLICK',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.LINK_CLICK,
      eventData: generateCampaignTagClickEvent(params),
    },
  }),
);

const sendImageViewEventActionCreators = generateAsyncActionCreators(
  'SEND_IMAGE_VIEW',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.IMAGE_VIEW,
      eventData: generateImageViewEvent(params),
    },
  }),
);

const sendProductViewEventActionCreators = generateAsyncActionCreators(
  'SEND_PRODUCT_VIEW',
  (params) => ({
    params: {
      eventName: DAVINCI_EVENT_NAMES.PRODUCT_VIEW,
      eventData: generateProductViewEvent(params),
    },
  }),
);

const actionCreators = {
  sendPageLoadEvent: {
    ...sendPageLoadEventActionCreators,
  },

  sendProductListEvent: {
    ...sendProductListEventActionCreators,
  },

  sendProductClickEvent: {
    ...sendProductClickEventActionCreators,
  },

  sendProductClickAnalyticsEvent: {
    ...sendProductClickAnalyticsEventActionCreators,
  },

  sendAddToCartClickEvent: {
    ...sendAddToCartClickEventActionCreators,
  },

  sendAddToCartAnalyticsEvent: {
    ...sendAddToCartClickAnalyticsEventActionCreators,
  },

  sendPreOrderClickEvent: {
    ...sendPreOrderClickEventActionCreators,
  },

  sendWebtrekkEvent: {
    ...sendWebtrekkEventActionCreators,
  },

  sendChangeVariant: {
    ...sendChangeVariantClickEventActionCreators,
  },

  sendOpenVariantPopup: {
    ...sendOpenVariantPopupEventActionCreators,
  },

  sendCloseVariantPopup: {
    ...sendCloseVariantPopupEventActionCreators,
  },

  sendFeedbackViewEvent: {
    ...sendFeedbackViewEventActionCreators,
  },

  sendFeedbackClickEvent: {
    ...sendFeedbackClickEventActionCreators,
  },

  sendFilterWidgetClickEvent: {
    ...sendFilterWidgetClickEventActionCreators,
  },

  sendTypoCorrectionViewEvent: {
    ...sendTypoCorrectionViewEventActionCreators,
  },

  sendTypoCorrectionClickEvent: {
    ...sendTypoCorrectionClickEventActionCreators,
  },

  sendRecoProductsClickEvent: {
    ...sendRecoProductsClickEventActionCreators,
  },

  sendRecoProductsViewEvent: {
    ...sendRecoProductsViewEventActionCreators,
  },

  sendRecoProductsArrowClickEvent: {
    ...sendRecoProductsArrowClickEventActionCreators,
  },

  sendDealOfTheDayTitleClickEvent: {
    ...sendDealOfTheDayTitleClickEventActionCreators,
  },

  sendDealOfTheDayProductsClickEvent: {
    ...sendDealOfTheDayProductsClickEventActionCreators,
  },

  sendDealOfTheDayArrowClickEvent: {
    ...sendDealOfTheDayArrowClickEventActionCreators,
  },

  sendDealOfTheDayViewEvent: {
    ...sendDealOfTheDayViewEventActionCreators,
  },

  sendFilterFacetClick: {
    ...sendFilterFacetClickEventActionCreators,
  },

  sendMultiFilterFacetClick: {
    ...sendMultiFilterFacetClickEventActionCreators,
  },

  sendSortClickEvent: {
    ...sendSortClickEventActionCreators,
  },

  sendSortClickAnalyticsEvent: {
    ...sendSortClickAnalyticsEventActionCreators,
  },

  sendSmartFilterViewEvent: {
    ...sendSmartFilterViewEventActionCreators,
  },

  sendHomePageViewEvent: {
    ...sendHomePageViewEventActionCreators,
  },

  sendRemoveFiltersEvent: {
    ...sendRemoveFiltersEventActionCreators,
  },

  sendSponsoredProductViewEvent: {
    ...sendSponsoredProductViewEventActionCreators,
  },

  sendSponsoredProductClickEvent: {
    ...sendSponsoredProductClickEventActionCreators,
  },

  sendProductListViewEvent: {
    ...sendProductListViewEventActionCreators,
  },

  sendCampaignTagClickEvent: {
    ...sendCampaignTagClickEventActionCreators,
  },

  sendImageViewEvent: {
    ...sendImageViewEventActionCreators,
  },

  sendProductViewEvent: {
    ...sendProductViewEventActionCreators,
  },
};

export {
  actionCreators,
  sendPageLoadEventActionCreators,
  sendProductListEventActionCreators,
  sendProductClickEventActionCreators,
  sendProductClickAnalyticsEventActionCreators,
  sendAddToCartClickEventActionCreators,
  sendPreOrderClickEventActionCreators,
  sendAddToCartClickAnalyticsEventActionCreators,
  sendChangeVariantClickEventActionCreators,
  sendOpenVariantPopupEventActionCreators,
  sendCloseVariantPopupEventActionCreators,
  sendWebtrekkEventActionCreators,
  sendFeedbackViewEventActionCreators,
  sendFeedbackClickEventActionCreators,
  sendFilterWidgetClickEventActionCreators,
  sendTypoCorrectionViewEventActionCreators,
  sendTypoCorrectionClickEventActionCreators,
  sendRecoProductsClickEventActionCreators,
  sendRecoProductsViewEventActionCreators,
  sendRecoProductsArrowClickEventActionCreators,
  sendDealOfTheDayTitleClickEventActionCreators,
  sendDealOfTheDayProductsClickEventActionCreators,
  sendDealOfTheDayArrowClickEventActionCreators,
  sendDealOfTheDayViewEventActionCreators,
  sendFilterFacetClickEventActionCreators,
  sendMultiFilterFacetClickEventActionCreators,
  sendSortClickEventActionCreators,
  sendSortClickAnalyticsEventActionCreators,
  sendProductListViewEventActionCreators,
  sendSmartFilterViewEventActionCreators,
  sendHomePageViewEventActionCreators,
  sendRemoveFiltersEventActionCreators,
  sendSponsoredProductViewEventActionCreators,
  sendSponsoredProductClickEventActionCreators,
  sendCampaignTagClickEventActionCreators,
  sendImageViewEventActionCreators,
  sendProductViewEventActionCreators,
};
